export default {"src":"/_next/static/media/apple.e9746fd7.svg","height":31,"width":30};